import { render, staticRenderFns } from "./scope95.vue?vue&type=template&id=97a33ace&scoped=true"
import script from "./scope95.vue?vue&type=script&lang=js"
export * from "./scope95.vue?vue&type=script&lang=js"
import style0 from "./scope95.vue?vue&type=style&index=0&id=97a33ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a33ace",
  null
  
)

export default component.exports